import { useKeyboardCommand } from "@hooks/keyboard/useKeyboardCommand";

interface ShortcutProps {
    shortcut: string;
    enabled: boolean;
    propertyLabel: string;
    open: () => void;
}

export function useSelectedTransactionsUpdateShortcut({
    shortcut,
    enabled,
    propertyLabel,
    open,
}: ShortcutProps) {
    useKeyboardCommand({
        keys: shortcut,
        callback: (event) => {
            event.preventDefault();
            event.stopPropagation();
            open();
        },
        options: {
            enabled,
            preventDefault: true,
            description: `Update ${propertyLabel}`,
        },
        dependencies: [enabled, open],
    });
}
